function toLowercaseEntityRefMaybe(entityRef, config) {
  if (config.getOptionalBoolean("techdocs.legacyUseCaseSensitiveTripletPaths"))
    return entityRef;
  entityRef.kind = entityRef.kind.toLocaleLowerCase();
  entityRef.name = entityRef.name.toLocaleLowerCase();
  entityRef.namespace = entityRef.namespace.toLocaleLowerCase();
  return entityRef;
}

export { toLowercaseEntityRefMaybe };
//# sourceMappingURL=helpers.esm.js.map
